import {
    ADMIN_LOGIN,
    CREATE_CUSTOMER,
    CREATE_LANGUAGE, DOWNLOAD_TRANSLATIONS, DOWNLOADED_TRANSLATIONS,
    GET_CUSTOMER,
    GET_CUSTOMERS,
    GET_LANGUAGE,
    GET_LANGUAGES,
    GET_PREDEFINED_TEXTS,
    GET_PROPERTY_DEFINITIONS,
    PRIVATE_CORE_LOGIN,
    PRIVATE_CORE_LOGOUT,
    SAVE_CUSTOMER,
    SAVE_LANGUAGE,
    SAVE_PREDEFINED_TEXT,
    SAVE_TRANSLATION_KEYS
} from "./action-types";
import CustomerService from "../services/CustomerService";
import PrivateCoreService from "../services/PrivateCoreService";
import {CREATE_MODE, DELETE_MODE, EDIT_MODE} from "../components/constants";
import {downloadedTranslations} from "./actions";

export const appMiddleware = (store) => (next) => (action) => {
    const privateCoreService = new PrivateCoreService(store.dispatch);
    const customerService = new CustomerService(store.dispatch);
    switch (action.type) {
        case ADMIN_LOGIN:
            customerService.login(action.payload.username, action.payload.password);
            next(action);
            break;

        case GET_CUSTOMERS: {
            const state = store.getState();
            customerService.getCustomers(state.jwt);
            next(action);
            break;
        }

        case GET_CUSTOMER: {
            const state = store.getState();
            customerService.getCustomer(state.jwt, action.payload.id);
            next(action);
            break;
        }

        case SAVE_CUSTOMER: {
            const state = store.getState();
            if(action.payload.mode === CREATE_MODE)
                customerService.createCustomer(state.jwt, action.payload.customer);
            else if(action.payload.mode === EDIT_MODE){
                customerService.editCustomer(state.jwt, action.payload.customer);
            }
            next(action);
            break;
        }

        case CREATE_CUSTOMER: {
            const state = store.getState();
            customerService.createCustomer(state.jwt, action.payload.customer);
            next(action);
            break;
        }

        case GET_LANGUAGES: {
            const state = store.getState();
            customerService.getLanguages(state.jwt);
            next(action);
            break;
        }

        case GET_LANGUAGE: {
            const state = store.getState();
            customerService.getLanguage(state.jwt, action.payload.id);
            next(action);
            break;
        }
        
        case SAVE_LANGUAGE: {
            const state = store.getState();
            if(action.payload.mode === CREATE_MODE)
                customerService.createLanguage(state.jwt, action.payload.language);
            else if(action.payload.mode === EDIT_MODE){
                customerService.editLanguage(state.jwt, action.payload.language);
            }
            next(action);
            break;
        }

        case DOWNLOAD_TRANSLATIONS: {
            const state = store.getState();
            customerService.downloadTranslations(state.jwt, action.payload.id, action.payload.flat, action.payload.format, downloadedTranslations);
            next(action);
            break;
        }

        case DOWNLOADED_TRANSLATIONS: {
            let saveLocalToDisk = function(filename, data) {
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
                element.setAttribute('download', filename);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            };

            let fileName;

            if(action.payload.metaData.customerId) {    // If its linked to a specific customer
                fileName = `messages.${action.payload.metaData.languageCode}.${action.payload.metaData.customerId}`;
            }
            else if(action.payload.metaData.master || action.payload.metaData.base) {
                fileName = `messages.${action.payload.metaData.languageCode}`;
            }
            else {
                fileName = `messages.${action.payload.metaData.id}`;
            }

            switch(action.payload.format) {
                case "json":
                    saveLocalToDisk(`${fileName}.json`, JSON.stringify(action.payload.translations));
                    break;
                case "yml":
                    saveLocalToDisk(`${fileName}.yml`,action.payload.translations);
                    break;
                default:
                    console.error(`Incorrect type ${action.payload.type}`);
                    break;
            }

            next(action);
            break;
        }

        case CREATE_LANGUAGE: {
            const state = store.getState();
            customerService.createLanguage(state.jwt, action.payload.language);
            next(action);
            break;
        }

        case SAVE_TRANSLATION_KEYS: {
            const state = store.getState();
            customerService.updateTranslationKeys(state.jwt, action.payload.id, action.payload.translationKeys);
            next(action);
            break;
        }

        case PRIVATE_CORE_LOGIN: {
            const state = store.getState();
            privateCoreService.login(state.currentCustomer, action.payload.username, action.payload.password);
            next(action);
            break;
        }

        case PRIVATE_CORE_LOGOUT: {
            const state = store.getState();
            if(typeof state.currentCustomer === "object" && typeof state.currentCustomer.id === "string") {
                const updatedAction = {...action};
                updatedAction.payload.customerId = state.currentCustomer.id;
                next(updatedAction);
            } else {
                next(action);
            }
            break;
        }

        case GET_PREDEFINED_TEXTS: {
            const state = store.getState();
            if(state.currentCustomer && action.payload.id === state.currentCustomer.id) {
                privateCoreService.getPredefinedTexts(state.currentCustomer, state.privateCoreJwt[state.currentCustomer.id], action.payload.limit, action.payload.page);
            }
            next(action);
            break;
        }

        case SAVE_PREDEFINED_TEXT: {
            const state = store.getState();
            if(action.payload.mode === CREATE_MODE) {
                privateCoreService.createPredefinedText(state.currentCustomer, state.privateCoreJwt[state.currentCustomer.id], action.payload.predefinedText);
            }
            else if(action.payload.mode === EDIT_MODE) {
                privateCoreService.editPredefinedText(state.currentCustomer, state.privateCoreJwt[state.currentCustomer.id], action.payload.predefinedText);
            }
            else if(action.payload.mode === DELETE_MODE) {
                privateCoreService.deletePredefinedText(state.currentCustomer, state.privateCoreJwt[state.currentCustomer.id], action.payload.predefinedText);
            }
            next(action);
            break;
        }

        case GET_PROPERTY_DEFINITIONS: {
            const state = store.getState();
            if(state.currentCustomer && action.payload.id === state.currentCustomer.id) {
                privateCoreService.getPropertyDefinitions(state.currentCustomer, state.privateCoreJwt[state.currentCustomer.id]);
            }
            next(action);
            break;
        }

        default:
            next(action);
            break;
    }
};


// WEBPACK FOOTER //
// ./src/redux/middleware.js